import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { AssetProductRequest } from '../models/dto/asset-product-request';
import { AssetProductCategoryRequest } from '../models/dto/asset-product-category-request';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';


@Injectable({
    providedIn: 'root'
})
export class AssetProductService {

    constructor(
        private networkService: LeanNetworkService,  
        public userService : UserService) { }


    //------------------------------------------------------------------------------------
    // Products Get
    //------------------------------------------------------------------------------------
    assetProductsGet(productCode : string, equipment  : boolean, spares : boolean): Promise<AssetProduct[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = productCode;
        request.blnArg1 = equipment;
        request.blnArg2 = spares;
       
        return new Promise((resolve, reject) => {
            this.networkService.post('services/masters/assetProductsGet', request).then(response => {
                resolve(response.assetProducts)
            }, error => {
                reject(error);
            });
        });
    }

    assetProductSave(assetProduct : AssetProduct) : Promise<AssetProduct>{
        let request : AssetProductRequest = new AssetProductRequest(this.userService.userInfo);
        request.assetProduct = assetProduct;
    
        return new Promise((resolve, reject) => {
            this.networkService.post('services/masters/assetProductSave', request).then(result => {           
                let assetProduct : AssetProduct = result.assetProduct;
                return resolve(assetProduct);  

            }, error => {
                reject(error);
            });
        });
    }


    //------------------------------------------------------------------------------------
    // Product Analysis Group
    //------------------------------------------------------------------------------------
    assetProductCategoriesGet(code : string): Promise<AssetProductCategory[]> {
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.strArg1 = code;        
    
        return new Promise((resolve, reject) => {
            this.networkService.post('services/masters/assetProductCategoriesGet', request).then(result => {
                return resolve(result.assetProductCategories);    
            }, error => {
                reject(error);
            });
        });
    }

    
    assetProductCategorySave(assetProductCategory : AssetProductCategory) : Promise<AssetProductCategory>{
        let request : AssetProductCategoryRequest = new AssetProductCategoryRequest(this.userService.userInfo);
        request.assetProductCategory = assetProductCategory;
    
        return new Promise((resolve, reject) => {
            this.networkService.post('services/masters/assetProductCategorySave', request).then(result => {                
                return resolve(result.assetProductCategory);  

            }, error => {
                reject(error);
            });
        });
    }
    

}
